// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8645) return "static/chunks/8645-f36095406bd8f11c.js";
	if (chunkId === 7917) return "static/chunks/7917-4deb0d023b293cf6.js";
	if (chunkId === 4985) return "static/chunks/4985-d58c38f9dcd6c378.js";
	if (chunkId === 449) return "static/chunks/449-0760ba868efaf2bf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"679":"67ebf7285ad04431","1712":"6104a380b1521352","1983":"e6d77f03303e3f11","2037":"d97d243e910009e5","3614":"b58d4a01fa131655","3793":"3e1ea816d02a3154","3906":"8218f2ba20d7d889","5564":"c3e5839435a57ec1","8504":"dcaed578f7d3e722","9911":"a7a5712de788078f","9922":"4cfed3d14949203c","9942":"7b1d20a1cedeea31"}[chunkId] + ".js";
};